import { z } from 'zod';

/** ULID — 26-char Crockford-base32, see blueprint §3. */
export const Ulid = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/, 'invalid ULID');
export type Ulid = z.infer<typeof Ulid>;

export const HexColor = z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'expected #RRGGBB');

export const Pagination = z.object({
  cursor: z.string().optional(),
  limit: z.number().int().min(1).max(100).default(25),
});
export type Pagination = z.infer<typeof Pagination>;

export function paginated<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
}

/** RFC 7807 Problem Details (blueprint §5). */
export const ProblemDetails = z.object({
  type: z.string().url(),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  instance: z.string().optional(),
  violations: z
    .array(
      z.object({
        field: z.string(),
        rule: z.string(),
        stage: z.string().optional(),
      }),
    )
    .optional(),
});
export type ProblemDetails = z.infer<typeof ProblemDetails>;
